module.exports = __webpack_public_path__ + "tools.1TWhMHVX.svg";